import { Component } from '@grafikr/components';
import fastdom from 'fastdom';

export default Component((node, { onMounted }) => {
  const videoTemplate = node.querySelector('template');
  const video = videoTemplate.content.firstElementChild as HTMLVideoElement;
  const preview = node.querySelector('img');
  const playButton = node.querySelector('button');

  const togglePlay = () => {
    if (video.paused) {
      video.play().catch(() => {});
    } else {
      video.pause();
    }
  };

  const onVideoPlay = () => {
    fastdom.mutate(() => {
      playButton!.hidden = true;
    });
  };

  const onVideoPause = () => {
    fastdom.mutate(() => {
      playButton!.hidden = false;
    });
  };

  onMounted(() => {
    node.appendChild(video);

    const shouldAutoplay = node.dataset.autoplay === 'true';

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    });

    if (shouldAutoplay) {
      observer.observe(node);
    }

    if (video.hasAttribute('controls') && !shouldAutoplay) {
      node.addEventListener(
          'click',
          () => {
            observer.disconnect();

            togglePlay();
          },
          { once: true },
      );

      if (playButton) {
        video.addEventListener('play', onVideoPlay);
        video.addEventListener('pause', onVideoPause);
      }
    } else if (!video.hasAttribute('controls')) {
      node.addEventListener('click', () => {
        observer.disconnect();

        togglePlay();
      });
    }

    video.addEventListener(
        'play',
        () => {
          fastdom.mutate(() => {
            video.hidden = false;
            preview.remove();
            videoTemplate.remove();
          });
        },
        { once: true },
    );
  });
});
